import { render, staticRenderFns } from "./portfolio-details.vue?vue&type=template&id=ef71786c&scoped=true&"
import script from "./portfolio-details.vue?vue&type=script&lang=js&"
export * from "./portfolio-details.vue?vue&type=script&lang=js&"
import style0 from "./portfolio-details.vue?vue&type=style&index=0&id=ef71786c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef71786c",
  null
  
)

export default component.exports